<dialog-header label='{{myLabel}}' [dialogRef]='dialogRef' (mousedown)="windowClick()" [autoClose]=false (onClose)="hide()" [object]='this'></dialog-header>
<div #mapSubArea class="map-sub-area">
  <div #newmiMap class="newmi-map"></div>
</div>
<div class="status-bar">
</div>
